import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import "./index.scss";

// Toast 提示框
export const Toast = (props) => {
  const {content, duration, onClose} = props;

  useEffect(() => {
    const timer = setTimeout(onClose, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return <div className="custom-toast__container-text">{content}</div>;
};

// Toast 提示框容器
export const ToastContainer = forwardRef((props, ref) => {
  const [toasts, setToasts] = useState([]);

  const addToast = (content, duration = 1000) => {
    const id = Math.random().toString(36).substring(2);
    setToasts((prevToasts) => [...prevToasts, {id, content, duration}]);
  };

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  useImperativeHandle(ref, () => ({
    addToast,
  }));

  return (
    <div className="custom-toast__container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          content={toast.content}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
});
